<svelte:options
  customElement={{
    tag: "ofc-placeholder-v1",
    props: {
      variant: {
        type: "String",
      },
      imageSrc: {
        type: "String",
        attribute: "image-src",
      },
    },
  }}
/>

<script lang="ts">
  import placeholder100 from "./assets/img-placeholder-100.png";
  import type { Props } from "./PlaceholderV1.types";

  let {
    variant = "text",
    imageSrc = placeholder100,
    imageAlt = "Placeholder Image",
  }: Props = $props();
</script>

<div class="placeholder" class:placeholder--image={variant === "image"}>
  {#if variant === "text"}
    <slot />
  {/if}
  {#if variant === "image"}
    <img src={imageSrc} alt={imageAlt} />
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :host {
    display: block;
    width: 100%;
    overflow: hidden;
    background-color: #30d9ba80;
  }

  :global {
    .placeholder {
      position: relative;
      font: tokens.$oc-semantic-font-copy-125;
      font-weight: bold;
      color: tokens.$oc-base-color-white;
      box-sizing: border-box;
      padding: tokens.$oc-semantic-spacing-100;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      line-height: tokens.$oc-base-font-line-height-150;
      outline: none;
      height: 100%;
      width: 100%;

      &--image {
        background-color: transparent;
        padding: 0;

        & > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
